import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceHasGateCodeIntegration,
  LocationVarKey.VoiceGateCodeHasAdditionalVerification,
  LocationVarKey.VoiceGateCodeAdditionalVerificationInfo,
  LocationVarKey.VoiceGateCodeFound,
  LocationVarKey.VoiceSendFoundGateCodeText,
  LocationVarKey.VoiceFoundGateCodeText,
  LocationVarKey.VoiceGateCodeNotFound,
  LocationVarKey.VoiceGateCodeMessage,
  LocationVarKey.VoiceSendGateCodeText,
  LocationVarKey.VoiceGateCodeTextMessage,
  LocationVarKey.VoiceForwardGateCode,
  LocationVarKey.VoiceGateCodeEscalateTo,
  LocationVarKey.VoiceGateCodePhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Gate Code</PageHeader>
      <br></br>
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceHasGateCodeIntegration}
        label="Use FMS to Lookup"
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCode, "1")}
      />

      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}>
        Gate Code Found
      </SectionHeader>
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceGateCodeHasAdditionalVerification}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        label="Verify Additional Information"
      />
      <InputRow
        {...page}
        hideIf={IF_ANY([
          IS_NOT_EQUAL(LocationVarKey.VoiceGateCodeHasAdditionalVerification, "1"),
          IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")
        ])}
        keyName={LocationVarKey.VoiceGateCodeAdditionalVerificationInfo}
        label="Information"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        marginTop
        label=" Voice Message"
        keyName={LocationVarKey.VoiceGateCodeFound}
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceSendFoundGateCodeText}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        label="Send SMS"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendFoundGateCodeText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceFoundGateCodeText}
      />
      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}>
        Gate Code Not Found
      </SectionHeader>
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        marginTop
        label=" Voice Message 1"
        keyName={LocationVarKey.VoiceGateCodeNotFound}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        marginTop
        label=" Voice Message 2"
        keyName={LocationVarKey.VoiceGateCodeMessage}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        marginTop
        label=" Voice Message"
        keyName={LocationVarKey.VoiceGateCodeMessage}
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceSendGateCodeText}
        hideIf={IS_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        label="Send SMS"
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceSendGateCodeText}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        label="Send SMS"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendGateCodeText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceGateCodeTextMessage}
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceForwardGateCode}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        label="Escalate"
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceForwardGateCode}
        hideIf={IS_EQUAL(LocationVarKey.VoiceHasGateCodeIntegration, "1")}
        label="Escalate"
      />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardGateCode, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoiceGateCodeEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />
      <Section
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceForwardGateCode, "1"), IS_EQUAL(LocationVarKey.VoiceGateCodeEscalateTo, "swivl")])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoiceGateCodePhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
